import JSZip from 'jszip'

/**
 *
 *
 * @export
 * @class FileUtils
 */
export default class FileUtils {
    constructor(url, fileName) {
        this.url = url
        this.fileName = fileName
    }

    readUrl() {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
    
            xhr.open('GET', this.url);
            xhr.responseType = 'blob';
            xhr.onload = ({ target: { response: res } }) => {
                const sourceFilename = this.url.split('/').splice(-1)[0]
                
                this.filename = this.fileName || sourceFilename
                this.blob = res
                resolve({ blob: res, filename: this.filename })
            }
            xhr.onerror = (err) => {
                reject(err)
            }
            xhr.send();
        })
    }

    toBase64() {
        return new Promise((resolve, reject) => {
            let fileReader = new FileReader();

            fileReader.onload = (e) => { 
                resolve(e)
            }
            fileReader.onerror = (err) => {
                reject(err)
            }
            fileReader.readAsDataURL(this.blob);
        })
    }

    toFile() {
        return new window.File([this.blob], this.name)
    }

    download(blob, filename){
        const blobUrl = window.URL.createObjectURL(blob || this.blob)
        const eleLink = document.createElement('a')

        eleLink.download = filename || this.filename
        eleLink.style.display = 'none'
        eleLink.href = blobUrl
        // 触发点击
        document.body.appendChild(eleLink)
        eleLink.click()
        // 然后移除
        document.body.removeChild(eleLink)
    }


    /**
     * 将数据转换为`zip blob`;
     * 示例: `FileUtils.zip({ fileName: '文件名字.jpg', data: 'wwww.xxx.cn/1.jpg' })`
     *
     * @static
     * @param {*} [list=[]]
     * @param {*} progressCB 进度回调
     * @memberof FileUtils
     */
    static async zip(list = [], progressCB) {
        const total = list.length
        const jszip = new JSZip()

        for(const idx in list) {
            let item = list[idx]
            let fileUtils = new FileUtils(item.data)

            let { blob } = await fileUtils.readUrl(item.data)

            jszip.file(item.fileName, blob)

            progressCB && progressCB(+idx + 1, total)
        }

        return await jszip.generateAsync({ type: 'blob' })
    }
}
